import axios from "axios";
import authHeader from "./auth-header";
import apihostname from "./apihostname";

const instance = axios.create({
  baseURL: apihostname,
  headers: authHeader(),
});

class SignNameTable {
  deleteSignname(id) {
    return instance.delete("/delete-sign-name/" + id);
  }
  getSignname() {
    return instance.get("/list-sign-name");
  }
  updateActive(body) {
    return instance.post("/active-sign-name/", body);
  }
  createSignname(body) {
    return instance.post("/create-sign-name/", body);
  }
}

export default new SignNameTable();
